// extracted by mini-css-extract-plugin
export var active = "_7x-a";
export var activeIndicator = "_7x-8";
export var animate = "_7x-9";
export var disabled = "_7x-b";
export var fullWidth = "_7x-2";
export var lg = "_7x-7";
export var md = "_7x-6";
export var redoButtonTabGroup = "_7x-0";
export var sm = "_7x-5";
export var tabButton = "_7x-3";
export var tabButtonsContainer = "_7x-1";
export var xs = "_7x-4";